<template>
    <div style="border: 1px solid #ccc">
        <Toolbar
            style="border-bottom: 1px solid #ccc"
            :editor="editorRef"
            :defaultConfig="toolbarConfig"
            :mode="mode"
        />
        <Editor
            style="height: 400px; overflow-y: hidden"
            v-model="localValue"
            :defaultConfig="editorConfig"
            :mode="mode"
            @onCreated="handleCreated"
        />
    </div>
</template>

<script setup>
import "@wangeditor/editor/dist/css/style.css";
import {
    ref,
    shallowRef,
    onBeforeUnmount,
    watch,
    defineProps,
    defineEmits,
} from "vue";
import { Editor, Toolbar } from "@wangeditor/editor-for-vue";

// ---------------------------
// 接收父组件的 v-model
// ---------------------------
const props = defineProps({
    modelValue: {
        type: String,
        default: "",
    },
    mode: {
        type: String,
        default: "default",
    },
});
const emit = defineEmits(["update:modelValue"]);

// 内部 value（用于绑定编辑器）
const localValue = ref(props.modelValue);

// 当内部内容改变 → 通知父组件
watch(localValue, (val) => emit("update:modelValue", val));

// 父组件修改 v-model，也同步到内部
watch(
    () => props.modelValue,
    (val) => {
        if (val !== localValue.value) {
            localValue.value = val;
        }
    }
);

// ---------------------------
// wangEditor 实例
// ---------------------------
const editorRef = shallowRef();
const mode = ref(props.mode);
const toolbarConfig = {};
const editorConfig = {
    placeholder: "请输入内容...",
    MENU_CONF: {
        uploadImage: {
            base64LimitSize: 10 * 1024 * 1024, // 小于 10MB 的图片都用 base64
        },
    },
};

const handleCreated = (editor) => {
    editorRef.value = editor;
};

// 组件销毁时释放实例
onBeforeUnmount(() => {
    const editor = editorRef.value;
    if (editor) {
        editor.destroy();
    }
});
</script>

<style scoped>
.w-e-container.fullscreen-mode {
    position: fixed !important;
    top: 0 !important;
    left: 0 !important;
    width: 100% !important;
    height: 100% !important;
    z-index: 9999 !important;
    background: #fff;
}
</style>
